import { render, staticRenderFns } from "./ImageDetail.vue?vue&type=template&id=7bf85f2e&scoped=true"
import script from "./ImageDetail.vue?vue&type=script&lang=js"
export * from "./ImageDetail.vue?vue&type=script&lang=js"
import style0 from "./ImageDetail.vue?vue&type=style&index=0&id=7bf85f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf85f2e",
  null
  
)

export default component.exports